import { Modal as ModalDS } from '@dasa-health/components-react'
import styled from 'styled-components'
import CustomTheme from 'theme'

export const Modal = styled(ModalDS)`
    &&& {
        padding: 24px 32px 32px;
        text-align: left;
        flex-direction: column;

        width: auto;
        max-width: 90%;
        margin: 0 auto;
        border-radius: 8px;
        height: auto;

        ${CustomTheme.breakPoint.tablet} {
            width: 550px;
            max-width: none;
        }

        > span {
            position: static;
            line-height: 1;
            align-self: flex-end;
        }
    }
`

export const ModalWrapper = styled.div`
    flex: 1 0;
    width: 100%;
    padding: 1rem 0 0;
    * > {
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    }
`

export const ModalTitle = styled.h1`
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 2rem;
    letter-spacing: 0;
    text-align: center;
    color: #161616;
    margin-bottom: 0.5rem;
`

export const ModalContent = styled.div`
    p,
    li {
        color: #666;
        line-height: 1.5rem;
        margin-bottom: 1.5rem;
        font-size: 1rem;
        text-align: center;
    }

    p span {
        color: #1636a5;
        font-weight: 500;
    }

    ul {
        margin-left: 1.25rem;
        li {
            list-style-type: disc;
            margin: 0;
        }
    }

    a {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        text-decoration: none;
    }
    div.container_illustration {
        margin: 0 0 3rem 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    h2 {
        color: #161616;
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.5rem;
        margin-bottom: 0.5rem;
    }
`
export const ModalFooter = styled.div`
    margin-top: 1.5rem;
`

export const CustomButton = styled.a`
    &&& {
        color: #fff;
        text-align: center;
        line-height: inherit;
        text-decoration: none;
        font-size: inherit;
        padding-left: 0.75em;
        padding-right: 0.75em;
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        border: 0;
        border-radius: 4px;
        width: 100%;
        border-radius: 8px;
        font-family: Montserrat, 'Dasa Sans', sans-serif;
        font-weight: 600;
        transition: all 200ms;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        padding-top: 1em;
        padding-bottom: 1em;
        padding-left: 1.5em;
        padding-right: 1.5em;
        font-size: 1em;
        height: 3em;
        background-color: #002ccc;

        &:hover {
            background-color: #002099;
        }
    }
`
